import { render, staticRenderFns } from "./visados.vue?vue&type=template&id=b5137a80"
import script from "./visados.vue?vue&type=script&lang=js"
export * from "./visados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports